import { LoadStatus } from '../../Types';
import type { InvoicesActionTypes } from './actions';
import { InvoicesActions } from './actions';
import type { InvoicesState } from './Types/InvoicesState';

const initialState: InvoicesState = {
    enabled: false,
    properties: {
        loadStatus: LoadStatus.INITIAL_STATE,
        sortOrder: [],
    },
};

// eslint-disable-next-line import/prefer-default-export
export function invoicesReducer(state: InvoicesState = initialState, action: InvoicesActionTypes): InvoicesState {
    switch (action.type) {
        case InvoicesActions.SET_INVOICES_ENABLED_STATUS:
            return {
                ...state,
                enabled: action.payload.enabled,
            };
        case InvoicesActions.LOAD_INVOICE_PROPERTIES:
            return {
                ...state,
                properties: {
                    loadStatus: LoadStatus.PENDING,
                },
            };
        case InvoicesActions.SET_INVOICE_PROPERTIES:
            return {
                ...state,
                properties: {
                    loadStatus: LoadStatus.LOADED,
                    ...action.payload.reduce(
                        (agg, curr) => ({
                            ...agg,
                            [curr.id]: curr,
                        }),
                        {},
                    ),
                    sortOrder: action.payload.map((property) => property.id),
                },
            };
        case InvoicesActions.SET_INVOICE_PROPERTIES_ERROR_STATE:
            return {
                ...state,
                properties: {
                    loadStatus: LoadStatus.ERROR,
                    errorState: action.payload.secondaryMessage
                        ? {
                              error: action.payload.errorMessage,
                              secondaryMessage: action.payload.secondaryMessage,
                          }
                        : { error: action.payload.errorMessage },
                    sortOrder: [],
                },
            };
        default:
            return state;
    }
}
